// extracted by mini-css-extract-plugin
export default {"container":"cu1Ymg7ke","content":"cKP6aV6RR","closeButton":"cMDAEJNKm","continueButton":"czEYxeoRg"};